// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import FoodSupportDashboard from "./Food/FoodSupportDashboard";
// import FoodTicketManagement from "./Food/FoodTicketManagement";
// // import SuperAdminLiveChatMonitor from "./SuperAdminLiveChatMonitor";
// import FoodKnowledgeBaseManager from "./Food/FoodKnowledgeBaseManager";

// const SuperAdminSupportSystem = () => {
//     const [activeTab, setActiveTab] = useState("dashboard");
//     const isMobile = window.innerWidth <= 768;

//     const tabContent = {
//         "dashboard": <FoodSupportDashboard />,
//         "tickets": <FoodTicketManagement />,
//         // "livechat": <SuperAdminLiveChatMonitor />,
//         "knowledgebase": <FoodKnowledgeBaseManager />,
//     };

//     const containerHeight = window.innerHeight > 600
//         ? (
//             window.innerWidth < 768
//                 ? '60vh'
//                 : window.innerWidth < 850
//                     ? '63vh'
//                     : window.innerWidth < 1400
//                         ? '65vh'
//                         : window.innerWidth < 1600
//                             ? '70vh'
//                             : '75vh'
//         )
//         : (
//             window.innerWidth < 768
//                 ? '300px'
//                 : window.innerWidth < 850
//                     ? '300px'
//                     : window.innerWidth < 1400
//                         ? '410px'
//                         : window.innerWidth < 1600
//                             ? '410px'
//                             : '450px'
//         );

//     return (
//         <>
//             <style>{`
//                 .superadmin-main-container {
//                     padding: 20px;
//                     display: flex;
//                     flex-direction: column;
//                 }

//                 .superadmin-tabs-wrapper {
//                     display: flex;
//                     flex-direction: column;
//                     align-items: center;
//                     gap: 10px;
//                 }

//                 .superadmin-tab-buttons {
//                     display: flex;
//                     justify-content: center;
//                     gap: 10px;
//                     margin-top: 81px;
//                     padding: 14px;
//                     flex-wrap: wrap;
//                 }

//                 .superadmin-tab-button {
//                     border: none;
//                     border-radius: 10px;
//                     width: auto;
//                     min-width: 120px;
//                     height: 45px;
//                     background-color: #d9d9d9;
//                     color: #000;
//                     font-weight: 500;
//                     cursor: pointer;
//                     transition: all 0.3s ease;
//                     font-size: 14px;
//                     white-space: nowrap;
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     gap: 8px;
//                 }

//                 .superadmin-tab-button.active {
//                     color: white;
//                     background-color: #6a0dad;
//                 }

//                 .superadmin-tab-content {
//                     margin-top: 20px;
//                     width: 100%;
//                     overflow-x: auto;
//                     overflow-y: scroll;
//                     background: white;
//                     border-radius: 10px;
//                     box-shadow: 0 2px 10px rgba(0,0,0,0.1);
//                 }

//                 .superadmin-tab-content::-webkit-scrollbar {
//                     width: 8px;
//                     height: 8px;
//                 }

//                 .superadmin-tab-content::-webkit-scrollbar-track {
//                     background: #f0f0f0;
//                     border-radius: 10px;
//                 }

//                 .superadmin-tab-content::-webkit-scrollbar-thumb {
//                     background: #6a0dad;
//                     border-radius: 10px;
//                 }

//                 @media (max-width: 768px) {
//                     .superadmin-tab-buttons {
//                         margin-top: 60px;
//                         padding: 10px;
//                     }

//                     .superadmin-tab-button {
//                         min-width: 100px;
//                         height: 40px;
//                         font-size: 12px;
//                     }
//                 }

//                 @media (max-width: 500px) {
//                     .superadmin-tab-button {
//                         min-width: 80px;
//                         font-size: 11px;
//                         height: 36px;
//                     }

//                     .superadmin-tab-buttons {
//                         gap: 5px;
//                     }
//                 }
//             `}</style>

//             <div className="container-fluid" style={{
//                 height: window.innerHeight < 500 ? "100vh" : "70vh",
//                 backgroundColor: "white",
//                 padding: "20px"
//             }}>
//                 <div className="row">
//                     {/* Left Column - Empty */}
//                     <div className="col-lg-2"></div>

//                     {/* Middle Column - Main Content */}
//                     <div className="col-lg-10">
//                         {/* Breadcrumb */}
//                         <p
//                             className="breadcrumb"
//                             style={{
//                                 position: "fixed",
//                                 top: window.innerWidth <= 500 ? "50px" : window.innerWidth > 500 && window.innerWidth <= 768 ? "55px" : "64px",
//                                 left: "2vw",
//                                 width: "100%",
//                                 backgroundColor: "#fff",
//                                 zIndex: 1000,
//                                 padding: "10px 0",
//                                 fontSize: isMobile ? "16px" : "18px",
//                                 fontWeight: isMobile ? "normal" : "bold",
//                                 textAlign: "center",
//                                 margin: 0,
//                                 boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
//                             }}
//                         >
//                             <Link
//                                 to="/superadmin"
//                                 style={{
//                                     color: "#6a0dad",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 SuperAdmin Dashboard
//                             </Link>
//                             <span className="separator"> &gt; </span>
//                             <Link
//                                 style={{
//                                     color: "#6a0dad",
//                                     fontWeight: "bold",
//                                     textDecoration: "none",
//                                 }}
//                             >
//                                 Support System
//                             </Link>
//                         </p>

//                         {/* Main Content Container */}
//                         <div style={{
//                             marginTop: window.innerWidth < 768 ? "80px" : "100px",
//                             padding: isMobile ? "15px" : "20px",
//                             backgroundColor: "#fff",
//                             borderRadius: "10px",
//                             width: window.innerWidth < 700 ? "94vw" : "auto",
//                         }}>
//                             {/* Tabs Wrapper */}
//                             <div className="superadmin-tabs-wrapper">
//                                 {/* Tab Buttons */}
//                                 <div className="superadmin-tab-buttons" style={{
//                                     flexWrap: window.innerWidth <= 562 ? "wrap" : "nowrap",
//                                     marginTop: window.innerWidth < 769 ? "60px" : "50px",
//                                     paddingLeft: window.innerWidth < 500 ? "0px" : " ",
//                                     paddingRight: window.innerHeight < 500 ? "25px" : " ",
//                                     marginRight: window.innerWidth < 769 ? " " : "20%"
//                                 }}>
//                                     <button
//                                         className={`superadmin-tab-button ${activeTab === "dashboard" ? "active" : ""}`}
//                                         onClick={() => setActiveTab("dashboard")}
//                                     >
//                                         📊 Dashboard
//                                     </button>
//                                     <button
//                                         className={`superadmin-tab-button ${activeTab === "tickets" ? "active" : ""}`}
//                                         onClick={() => setActiveTab("tickets")}
//                                     >
//                                         🎫 Ticket Management
//                                     </button>
//                                     <button
//                                         className={`superadmin-tab-button ${activeTab === "livechat" ? "active" : ""}`}
//                                         onClick={() => setActiveTab("livechat")}
//                                     >
//                                         💬 Live Chat Monitor
//                                     </button>
//                                     <button
//                                         className={`superadmin-tab-button ${activeTab === "knowledgebase" ? "active" : ""}`}
//                                         onClick={() => setActiveTab("knowledgebase")}
//                                     >
//                                         📚 Knowledge Base
//                                     </button>
//                                 </div>

//                                 {/* Tab Content */}
//                                 <div
//                                     className="superadmin-tab-content"
//                                     style={{
//                                         height: containerHeight,
//                                         overflowX: "auto",
//                                         overflowY: "scroll",
//                                         width: window.innerWidth < 450 ? "90vw" : " ",
//                                         padding: "20px",
//                                         backgroundColor: "#fff",
//                                         borderRadius: "8px",
//                                     }}
//                                 >
//                                     {tabContent[activeTab]}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default SuperAdminSupportSystem;













import React, { useState } from "react";
import { Link } from "react-router-dom";

import FoodSupportDashboard from "./Food/FoodSupportDashboard";
import FoodTicketManagement from "./Food/FoodTicketManagement";
import FoodKnowledgeBaseManager from "./Food/FoodKnowledgeBaseManager";
import "./Food/Foodsupportsystem.css"

const SuperAdminSupportSystem = () => {
    const [activeTab, setActiveTab] = useState("Dashboard");

    const tabContent = {
        "Dashboard": <FoodSupportDashboard />,
        "Ticket Management": <FoodTicketManagement />,
        "Knowledge Base": <FoodKnowledgeBaseManager />,
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10" style={{ height: "100vh", overflowY: "auto" }}>
                    {/* BREADCRUMB */}
                    <p
                        className="breadcrumb maamaas-home-bredcum or7"
                        style={{
                            position: "fixed",
                            top: "57px",
                            left: "1vw",
                            width: "100%",
                            backgroundColor: "#fff",
                            // zIndex: 1000,
                            padding: "10px 0",
                            fontSize: "18px",
                            fontWeight: "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Homes"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>

                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            <Link
                                style={{
                                    color: "purple",
                                    fontWeight: "bold",
                                    textDecoration: "none",
                                }}
                            >
                                Support System
                            </Link>
                        </span>
                        <span className="separator"> &gt; </span>
                        <span
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Food & Beverages
                        </span>
                    </p>

                    {/* TAB BUTTONS CONTAINER */}
                    <div className="sticky-top" style={{
                        top: '90px',
                        backgroundColor: 'white',
                        zIndex: 99,
                        padding: '15px 0',
                        // borderBottom: '1px solid #eee'
                    }}>
                        <div className="row g-2 justify-content-center  support-res">
                            {Object.keys(tabContent).map((label) => (
                                <div className="col-auto" key={label}>
                                    <button
                                        onClick={() => setActiveTab(label)}
                                        style={{
                                            border: "none",
                                            borderRadius: "10px",
                                            width: "160px",
                                            height: "45px",
                                            backgroundColor: activeTab === label ? "#b15cd6" : "#d9d9d9",
                                            color: activeTab === label ? "#fff" : "#000",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "all 0.3s ease",
                                            textAlign: "center",
                                            lineHeight: "1",
                                            padding: "0",
                                            margin: "0 5px",
                                        }}
                                    >
                                        {label}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* TAB CONTENT */}
                    <div style={{
                        marginTop: "60px",
                        height: "calc(110vh - 200px)",
                        overflowY: "auto",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        padding: "20px",
                    }}>
                        {tabContent[activeTab]}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuperAdminSupportSystem;